import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { renderPlayerCell } from "./usePassingTable";
import { createTableData, teamGameLeaders } from "./utils";
import type { GetGameLeadersQuery } from "@/graphql/gql/graphql";

type Data = ReturnType<typeof teamGameLeaders>;

const createColumns = () => {
  const columnHelper = createColumnHelper<Data>();

  return [
    columnHelper.group({
      id: "receiving",
      header: "Receiving Yards",
      columns: [
        columnHelper.accessor("receiving_leader", {
          header: "Name",
          cell: renderPlayerCell,
        }),
        columnHelper.accessor("receiving_receptions", {
          header: "REC",
        }),
        columnHelper.accessor("receiving_yards", {
          header: "REC YDS",
        }),
        columnHelper.accessor("receiving_touchdowns", {
          header: "REC TDS",
        }),
      ],
    }),
  ];
};

const useReceivingTable = (data: GetGameLeadersQuery["event"]) => {
  const tableData = useMemo(() => createTableData(data), [data]);
  const columns = useMemo(createColumns, []);
  return {
    columns,
    data: tableData,
  };
};

export default useReceivingTable;
